import { createAsyncThunk } from "@reduxjs/toolkit";
import { StoreState, ThunkDispatch } from "../types/index.js";

export const createAppAsyncThunk = createAsyncThunk.withTypes<{
  state: StoreState;
  dispatch: ThunkDispatch;
}>();
